import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";
import heroImage from "@/assets/hero-interior.jpg";

const HeroSection = () => {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="تصميم داخلي فاخر - حسن عبدالله للمقاولات والديكورات"
          width={1920}
          height={1080}
          fetchPriority="high"
          decoding="async"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/70 to-charcoal/30" />
      </div>

      <div className="relative z-10 container mx-auto text-center px-4">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="max-w-3xl mx-auto"
        >
          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="w-20 h-0.5 gold-gradient mx-auto mb-8"
          />
          <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold text-marble mb-4 sm:mb-6 leading-tight">
            حسن عبدالله
            <br />
            <span className="gold-text">للمقاولات والديكورات</span>
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-marble/80 mb-8 sm:mb-10 max-w-xl mx-auto leading-relaxed px-2">
            خبرة وجودة في الرياض — نحوّل رؤيتكم إلى واقع فاخر بأيدي فريق متخصص في التصميم الداخلي والترميم والمقاولات
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              asChild
              size="lg"
              className="bg-primary text-primary-foreground hover:bg-gold-dark font-semibold px-10 py-6 text-lg gold-shadow"
            >
              <a href="#contact">طلب عرض سعر</a>
            </Button>
            <a
              href="tel:+966556641963"
              className="inline-flex items-center justify-center gap-2 border border-primary/50 font-semibold text-base sm:text-lg rounded-md transition-colors cursor-pointer py-3 px-8 sm:px-12 bg-charcoal/20 text-primary"
            >
              <Phone className="w-5 h-5 text-primary" />
              اتصل الآن
            </a>
          </div>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
      />

    </section>
  );
};

export default HeroSection;
